import { Commit, DataFlow, Gear, User } from "components/icons/generated";
import Icon from "ds/components/Icon";
import { isFlowsTrigger } from "utils/flows";

import styles from "./styles.module.css";

type RunTriggerCommitProps = {
  triggeredBy?: string;
};

const RunTriggerCommit = ({ triggeredBy }: RunTriggerCommitProps) => {
  let iconSrc = User;
  if (!triggeredBy) {
    iconSrc = Commit;
  }

  if (triggeredBy?.startsWith("policy/")) {
    iconSrc = Gear;
  }

  if (triggeredBy?.startsWith("reconciliation/")) {
    iconSrc = Gear;
  }

  if (isFlowsTrigger(triggeredBy)) {
    iconSrc = DataFlow;
  }

  return (
    <span className={styles.iconWrapper}>
      <Icon src={iconSrc} className={styles.icon} />
    </span>
  );
};

export default RunTriggerCommit;
